import React from 'react';
import { HStack, Text } from 'native-base';
import Functions from '../../../utils/Functions';
import IconResolver from '../StatusTracker/IconResolver';
export const statusColor = {
  'Pending': '#0A4A8D',
  'Not Started': '#656565',
  'Complete': '#222A34'
};

/**
 * Individual loan status
 * @param state represents the each loan state
 * @returns each loan state
 */
export const LoanStatus = _ref => {
  let {
    state
  } = _ref;
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconResolver, {
    stepName: state.stepName,
    status: state.status
  }), /*#__PURE__*/React.createElement(Text, {
    color: statusColor[state.status],
    marginLeft: 3,
    accessibilityLabel: state.status.toLowerCase(),
    testID: state.status.toLowerCase()
  }, Functions.startCase(state.stepName.toLowerCase())));
};
//# sourceMappingURL=index.js.map